import React from 'react'
import SmashPapi from '../../assets/SmashPapi_Pp.jpeg'

const VideoDescription = ({ contributor, description, title }) => {
    return (
        <div className='px-3 px-lg-0 mb-4'>
            {/* <div className='d-flex d-sm-none flex-column mt-3'>
                <p className='microtext' style={{color: "rgb(174, 175, 186)"}}>Lesson 2</p>
                <h4 className='mb-0'>{title || 'Untitled Video'}</h4>
            </div> */}
            <div className="d-flex mt-3" style={{alignItems: "center"}}>
                <img src={SmashPapi} alt="Smash Papi" style={{ width: "50px", height: "50px", borderRadius: "50%" }} />
                <div className="ms-3">
                    <p className='m-0'>by {contributor}</p>
                    <p className='m-0 microtext' style={{color: "rgb(174, 175, 186)"}}>from <span style={{color: "#FFCC19"}}>Melee Foundation</span></p>
                </div>
            </div>
            <div className="mt-3">
                <h4>Lesson Summary</h4>
                <p>
                    {description?.summary || 'Something went wrong. Please try again later.'}
                </p>
                {description?.resources && Object.keys(description.resources).length > 0 && (
                    <div>
                        <h4 className="mt-3">Useful Links</h4>
                        {/* The links are a list where index 0 is the name and index 1 is the URL */}
                        {/* Resources is an object with arrays */}
                        {Object.entries(description.resources).map(([key, link]) => (
                            <div key={key} className="mb-3">
                                <a href={link[1]} target="_blank" rel="noopener noreferrer" style={{color: "#FFCC19"}}>{link[0]}</a>
                            </div>
                        ))}
                    </div>
                )}
                {/* <h5 className="mt-3">Timestamps</h5>
                <p>
                    {description?.timestamps || 'Something went wrong. Please try again later.'}
                </p> */}
            </div>
        </div>
    )
}

export default VideoDescription